:host {
    --z-index-bubble-selected: 3;
    --z-index-bubble-in-front: 4;
    --z-index-bubble-unselected: 1;

    display: block;
    width: 100%;
    height: 100%;
    position: relative;

    .field-container {
        // Evita que el navegador interprete el drag/lasso como scroll, zoom o
        // selección/callout nativo, especialmente en tablets y móviles.
        touch-action: none;
        -webkit-touch-callout: none;
        user-select: none;
    }

    .in-front {
        z-index: var(--z-index-bubble-in-front) !important;
    }

    // Oculta visualmente el anunciador de accesibilidad sin removerlo del árbol de accesibilidad
    .a11y-announcer {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border: 0;
    }
}